import { useQuery } from "@tanstack/react-query";
import { rawMaterialApi} from "../../raw-material/service/rawMaterialApi";
import { checkTokenValidity } from "../../user/services/AuthProvider";
import { ERMMEndPoint } from "../../raw-material/service/rawMaterialApi";
import { IStandardResponse } from "../models/order";
import { ICompany, IDeliver, IDestination, IIncoterm, IOrderType, IPaymentTerm, IProcessType, ISalesperson, IShippingMode, ISupplier, ISupplierTypeLocation } from "../../raw-material/models/rmm_models";

export const usePaymentTerm = (enabled:boolean=true) => {
  const query = useQuery<IStandardResponse<Array<IPaymentTerm>>, Error>({
    queryKey: [ERMMEndPoint.PAYMENT_TERM],
    queryFn: () => rawMaterialApi.getPaymentTerm(),
    enabled: enabled ,
  });
  const { data } = query.data || {};
  return {
    ...query,
    data: data,
  };
};
export const useSuppliers = () => {
  const query = useQuery<IStandardResponse<Array<ISupplier>>, Error>({
    queryKey: [ERMMEndPoint.SUPPLIER],
    queryFn: () => rawMaterialApi.getSuppliers(),
  });
  const { data } = query.data || {};
  return {
    ...query,
    data: data,
  };
};
export const useShippingMode = (enabled:boolean=true) => {
  const query = useQuery<IStandardResponse<Array<IShippingMode>>, Error>({
    queryKey: [ERMMEndPoint.SHIPPING_MODE],
    queryFn: () => rawMaterialApi.getShippingMode(),
    enabled: enabled
  });
  const { data } = query.data || {};
  return {
    ...query,
    data: data,
  };
};

export const useIncoterms = (enabled:boolean=true) => {
  const query = useQuery<IStandardResponse<Array<IIncoterm>>, Error>({
    queryKey: [ERMMEndPoint.INCOTERM],
    queryFn: () => rawMaterialApi.getIncoterms(),
    enabled: enabled
  });
  const { data } = query.data || {};
  return {
    ...query,
    data: data,
  };
};

export const useCompanies = (enabled:boolean=true) => {
  const query = useQuery<IStandardResponse<Array<ICompany>>, Error>({
    queryKey: [ERMMEndPoint.COMPANIES],
    queryFn: () => 
      rawMaterialApi.getCompanies(),
    enabled: enabled && checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};

export const useDestinations = () => {
  const query = useQuery<IStandardResponse<Array<IDestination>>, Error>({
    queryKey: [ERMMEndPoint.DESTINATION],
    queryFn: () => rawMaterialApi.getDestinations(),
    enabled: checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};

export const useDelivery = (enabled:boolean=true) => {
  const query = useQuery<IStandardResponse<Array<IDeliver>>, Error>({
    queryKey: [ERMMEndPoint.DELIVER],
    queryFn: () => rawMaterialApi.getDelivery(),
    enabled: enabled && checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};

export const useOrderType = () => {
  const query = useQuery<IStandardResponse<Array<IOrderType>>, Error>({
    queryKey: [ERMMEndPoint.ORDER_TYPE],
    queryFn: () => rawMaterialApi.getOrderType(),
    enabled: checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};

export const useSalesPerson = () => {
  const query = useQuery<IStandardResponse<Array<ISalesperson>>, Error>({
    queryKey: [ERMMEndPoint.SALES_PERSON],
    queryFn: () => rawMaterialApi.getSalesPerson(),
    enabled: checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};







export const useTypedSuppliers = (type: string) => {
  const query = useQuery<IStandardResponse<Array<ISupplier>>, Error>({
    queryKey: [ERMMEndPoint.TYPED_SUPPLIER, type],
    queryFn: () => rawMaterialApi.getTypedSuppliers(type),
    enabled: checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};


export const useSuppliersTypeLocation = () => {
  const query = useQuery<
    IStandardResponse<Array<ISupplierTypeLocation>>,
    Error
  >({
    queryKey: [ERMMEndPoint.SUPPLIER_TYPE_LOCATION],
    queryFn: () => rawMaterialApi.getSuppliersTypeLocation(),
    enabled: checkTokenValidity(),
  });

  const { data } = query.data || {};

  return {
    ...query,
    data: data,
  };
};

export const useProcessType = () => {
  const query = useQuery<IStandardResponse<Array<IProcessType>>, Error>({
    queryKey: [ERMMEndPoint.PROCESS_TYPE],
    queryFn: () => rawMaterialApi.getProcessType(),
  });
  const { data } = query.data || {};
  return {
    ...query,
    data: data,
  };
};


// export const useGetFcdOrders = (queryOptions?: { enabled?: boolean }) => {
//   const query = useQuery({
//     queryKey: [ERMMEndPoint.ORDER_FCD],
//     queryFn: () => rawMaterialApi.getYarnOrdersFcd(),
//     enabled: queryOptions?.enabled ?? false,
//   });

//   // La réponse réelle est: { success, data: { data: IFcdOrder[], pagination: {...} } }
//   const rawData = query.data?.data;
//   const orders: IFcdOrder[] = Array.isArray(rawData)
//     ? rawData                          // si data est directement un tableau
//     : (rawData as any)?.data ?? [];   // si data est { data: [], pagination: {} }

//   return {
//     ...query,
//     data: orders,
//   };
// };